import { z } from 'zod';
import { GRADE_LEVEL_NAME_MAX } from './grade-level.js';
import { SUBJECT_NAME_MAX } from './subject.js';
import { IsoTimestamp, SchoolId, UserId } from './common.js';
import { Question } from './quiz.js';
export const AI_QUESTION_MAX_PER_REQUEST = 10;
export const AiQuestionDifficulty = z.enum(['easy', 'medium', 'hard']);
export const GenerateAiQuestionsRequest = z.object({
    subject: z.string().trim().min(1).max(SUBJECT_NAME_MAX),
    gradeLevel: z.string().trim().min(1).max(GRADE_LEVEL_NAME_MAX),
    topic: z.string().trim().min(3).max(300),
    capaian: z.string().trim().min(1).max(200),
    difficulty: AiQuestionDifficulty,
    type: z.enum(['mcq', 'essay']).default('mcq'),
    count: z.number().int().min(1).max(AI_QUESTION_MAX_PER_REQUEST).default(5),
});
export const AiQuestionDraftStatus = z.enum(['pending_review', 'approved', 'rejected']);
/** A generated item awaiting teacher review. It is never in the question bank until approved. */
export const AiQuestionDraft = z.object({
    id: z.string().min(1).max(128),
    schoolId: SchoolId,
    requestedBy: UserId,
    generationId: z.string().min(1).max(128),
    status: AiQuestionDraftStatus,
    subject: z.string().max(SUBJECT_NAME_MAX),
    gradeLevel: z.string().max(GRADE_LEVEL_NAME_MAX),
    topic: z.string().max(300),
    capaian: z.string().max(200),
    difficulty: AiQuestionDifficulty,
    question: Question,
    createdAt: IsoTimestamp,
    reviewedAt: IsoTimestamp.optional(),
    reviewedBy: UserId.optional(),
    questionBankItemId: z.string().max(128).optional(),
});
/** Approving may carry the teacher's edited version of the question. */
export const ApproveAiQuestionDraftRequest = z.object({
    question: Question.optional(),
});
//# sourceMappingURL=question-ai.js.map